<template>
      <b-badge :variant="getBadgeColor(text)"> {{ text }} </b-badge>
</template>

<script>
  import {Membership} from "../../models/Membership";
  import {News} from "../../models/News/News";
  import {Campaign} from "@/models/NewsLetter/Campaign";

  const SUCCESS_VALUES = [
      Membership.STATUS.ACTIVE,
      News.STATUS.PUBLISHED,
      'paid',
      Campaign.STATUS.COMPLETED,
  ];

  const DARK_VALUES = [
      Membership.TYPES.ACTIVE_MEMBER,
  ];

  const DANGER_VALUES = [
      Membership.STATUS.CANCELLED,
      News.STATUS.DISABLED,
  ];

  const PRIMARY_VALUES = [
      Membership.TYPES.SUPPORTING_MEMBER,
      Membership.STATUS.CREATED,
  ];

  const WARNING_VALUES = [
    News.STATUS.SCHEDULED,
  ]

  export default {
      name: "app-btn",
      props: {
          text: {
              type: String,
              default: "",
          },
      },
      methods: {
          getBadgeColor (value) {
              if (SUCCESS_VALUES.includes(value)) {
                  return 'success'
              }

              if (DANGER_VALUES.includes(value)) {
                  return 'danger'
              }

              if (DARK_VALUES.includes(value)) {
                  return 'dark'
              }

              if (PRIMARY_VALUES.includes(value)) {
                  return 'primary'
              }

              if (WARNING_VALUES.includes(value)) {
                return 'warning'
              }

              return 'secondary'
          },
      },
  }
</script>

<style scoped>

</style>
